/* bios-cart.js — SYS_CART panel: open/close, load items, remove with glitch.
   Extracted from main-content.liquid to stay within Shopify's 256 KB limit. */
(function initCart() {
  'use strict';
  var cartBtn   = document.getElementById('bios-syscart-btn');
  var cartPanel = document.getElementById('bios-cart-panel');
  var cartBody  = document.getElementById('bios-cart-panel-body');
  var cartFoot  = document.getElementById('bios-cart-panel-foot');
  var cartClose = document.getElementById('bios-cart-close-btn');
  if (!cartBtn || !cartPanel) return;
  var cartOpen = false;

  function openCart() {
    cartOpen = true;
    cartPanel.setAttribute('aria-hidden', 'false');
    cartPanel.classList.add('is-open');
    cartBtn.setAttribute('aria-expanded', 'true');
    try { if (window.BiosAudio) window.BiosAudio.overlayOpen(); } catch (_) {}
    loadCart();
  }
  function closeCart() {
    cartOpen = false;
    cartPanel.setAttribute('aria-hidden', 'true');
    cartPanel.classList.remove('is-open');
    cartBtn.setAttribute('aria-expanded', 'false');
    try { if (window.BiosAudio) window.BiosAudio.overlayClose(); } catch (_) {}
  }
  function toggleCart() { if (cartOpen) closeCart(); else openCart(); }

  function loadCart() {
    if (cartBody) cartBody.innerHTML = '<div class="bios-cart-loading">QUERYING /CART...</div>';
    if (cartFoot) cartFoot.innerHTML = '';
    fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        if (!cart.items || cart.items.length === 0) {
          if (cartBody) cartBody.innerHTML = '<div class="bios-cart-empty">// CART IS EMPTY</div>';
          return;
        }
        var html = '';
        cart.items.forEach(function(item) {
          var title = (item.product_title || item.title || 'ITEM').toUpperCase();
          if (title.length > 22) title = title.slice(0, 21) + '…';
          var price = '$' + (item.final_line_price / 100).toFixed(2);
          var key   = String(item.key || item.variant_id);
          /* item.image returns a CDN URL with default sizing; rewrite to
             120w to keep payload tight on the 44px thumb. */
          var img = item.image
            ? item.image.replace(/\.([a-z]+)(\?.*)?$/i, '_120x.$1$2')
            : '';
          var thumb = img
            ? '<span class="bios-ci-thumb" style="background-image:url(\'' + img.replace(/'/g, "\\'") + '\')"></span>'
            : '<span class="bios-ci-thumb bios-ci-thumb-empty"></span>';
          html += '<div class="bios-cart-item" data-key="' + key + '">' +
            thumb +
            '<span class="bios-ci-qty">' + item.quantity + '×</span>' +
            '<span class="bios-ci-name">' + title + '</span>' +
            '<span class="bios-ci-price">' + price + '</span>' +
            '<button class="bios-ci-remove" data-key="' + key + '" aria-label="Remove">✕</button>' +
            '</div>';
        });
        if (cartBody) cartBody.innerHTML = html;
        if (cartFoot) {
          var total = '$' + (cart.total_price / 100).toFixed(2);
          cartFoot.innerHTML =
            '<div class="bios-cart-rule"></div>' +
            '<div class="bios-cart-total"><span>TOTAL</span><span>' + total + '</span></div>' +
            '<a href="/checkout" class="bios-cart-checkout">[ PROCEED TO CHECKOUT ]</a>' +
            '<a href="/cart" class="bios-cart-viewall">[ VIEW CART ]</a>';
        }
      })
      .catch(function() {
        if (cartBody) cartBody.innerHTML = '<div class="bios-cart-empty">// ERROR READING CART</div>';
      });
  }

  /* Remove item — glitch out the row then delete from cart */
  function removeCartItem(key, rowEl) {
    if (!rowEl || rowEl.classList.contains('is-removing')) return;
    rowEl.classList.add('is-removing');
    try { if (window.BiosAudio) window.BiosAudio.cartRemove(); } catch (_) {}
    setTimeout(function() {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      })
      .then(function() { loadCart(); })
      .catch(function() { rowEl.classList.remove('is-removing'); });
    }, 380);
  }

  /* Event delegation — catches remove clicks on dynamically rendered rows */
  if (cartBody) {
    cartBody.addEventListener('click', function(e) {
      var btn = e.target.closest('.bios-ci-remove');
      if (!btn) return;
      e.stopPropagation();
      var key = btn.dataset.key;
      var row = cartBody.querySelector('.bios-cart-item[data-key="' + key + '"]');
      removeCartItem(key, row);
    });
  }

  /* Checkout modem handshake is now wired globally in
     bios-page-transitions.js so it fires for all three checkout paths
     (.bios-cart-checkout, .bios-cart-pg-checkout, .ps-cart-checkout)
     with consistent music ducking. Local handler removed to avoid
     double-play on the panel checkout. */

  cartBtn.addEventListener('click', function(e) { e.stopPropagation(); toggleCart(); });
  if (cartClose) cartClose.addEventListener('click', function(e) { e.stopPropagation(); closeCart(); });

  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape' && cartOpen) closeCart();
  });
  document.addEventListener('click', function(e) {
    if (cartOpen && !cartPanel.contains(e.target) && e.target !== cartBtn) closeCart();
  });
})();
